/**
 * Versandkosten-Rechner Logik
 * Aktualisiert Preise basierend auf dem Nutzerland.
 * * Voraussetzung: 
 * Im Liquid-Template muss vor dem Laden dieses Scripts 
 * die Variable window.shopUserCountry gesetzt sein.
 */

document.addEventListener("DOMContentLoaded", function() {
  updateShippingThresholds();
});

function updateShippingThresholds() {
  // 1. Das aktuelle Land aus der globalen Variable holen (definiert im Liquid)
  // Fallback auf 'DE', falls die Variable noch nicht existiert
  var userCountry = window.shopUserCountry || 'DE';

  // 2. Definition der Schwellenwerte
  var shippingRules = {
    'DE': { amount: 30, currency: '€' }, // Deutschland
    'AT': { amount: 35, currency: '€' }, // Österreich
    'NL': { amount: 35, currency: '€' }, // Niederlande
    'BE': { amount: 35, currency: '€' }, // Belgien
    'FR': { amount: 45, currency: '€' }, // Frankreich
    'IT': { amount: 45, currency: '€' }, // Italien
    'ES': { amount: 45, currency: '€' }, // Spanien
    'CH': { amount: 199, currency: '€' }, // Schweiz
    'LI': { amount: 199, currency: '€' }, // Lichtenstein
    'LU': { amount: 35, currency: '€' }, // Luxemburg
    'GB': { amount: 35, currency: 'GBP' }, // Großbritannien
    'IE': { amount: 40, currency: '€' }, // Irland
    'NO': { amount: 447, currency: 'NOK' }, // Norwegen
    'PL': { amount: 174, currency: 'PLN' }, // Polen
    'PT': { amount: 45, currency: '€' }, // Portugal
    'RO': { amount: 250, currency: 'RON' }, // Rumänien
    'CZ': { amount: 1250, currency: 'CZK' }, // Tschechien
    'HR': { amount: 35, currency: '€' }, // Kroatien
    'DK': { amount: 290, currency: 'DKK' } // Dänemark
  };

  // 3. Alle Elemente finden, die aktualisiert werden sollen
  // Wir suchen nach der ID (für deinen Banner) UND nach einer Klasse (für andere Stellen im Shop)
  var elements = document.querySelectorAll('#shipping-threshold, .js-shipping-threshold');
  
  // 4. Logik auf alle gefundenen Elemente anwenden
  elements.forEach(function(element) {
    if (userCountry && shippingRules[userCountry]) {
      var rule = shippingRules[userCountry];
      element.textContent = rule.amount + (rule.currency === '€' ? ' €' : ' ' + rule.currency);
    } else {
      // Fallback für Länder ohne definierte Regel
      element.textContent = "30€"; 
    }
  });

}